import { render, staticRenderFns } from "./basePrice.vue?vue&type=template&id=557050d4&scoped=true"
import script from "./basePrice.vue?vue&type=script&lang=js"
export * from "./basePrice.vue?vue&type=script&lang=js"
import style0 from "./basePrice.vue?vue&type=style&index=0&id=557050d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557050d4",
  null
  
)

export default component.exports